import { IApplicationState } from '../../../../../../types/types';
import { getAsidePanel } from './getAsidePanel';
import { ASIDE_COLUMN_MIN_WIDTH } from '../../../../../../const';
import { getUserCommentsColumnView } from '../../../../../../store/model/authUser/selectors/getUserCommentsColumnView';

export const getAsidePanelColumnWidth = (
    state: IApplicationState
): number => {
    if (!getUserCommentsColumnView(state)) return 0;
    return getAsidePanel(state).columnWidth || ASIDE_COLUMN_MIN_WIDTH;
};
